module.exports = __webpack_public_path__ + "assets/img/pay-result-icon.cc4a0be9.png";